export default "__VITE_ASSET__BUOnnigM__"